@if (ticket.Service_Location_Address__c) {
  <div class="location-service mt-4 md:mt-0 mb-2 pr-6">
    <div class="location">
      <div class="label">Location of Service</div>
      <div class="icon-text">
        <div class="custom-icon location_dark">location</div>
        {{ ticket.Service_Location_Address__c | uppercase }}
      </div>
    </div>
    <div class="service mt-4 md:mt-2">
      <div class="label">Service</div>
      <div class="icon-text">
        <div class="custom-icon circuit_dark">circuit</div>
        <span>
          {{ ticket.Service__r ? ticket.Service__r.Name : '- - -' }} -
          {{
            ticket.Service__r.RecordType
              ? ticket.Service__r.RecordType.Name
              : '- - -'
          }}
          @if (ticket.Service__r.Bandwidth_Downstream__c) {
            - {{ ticket.Service__r.Bandwidth_Downstream__c }}
          }
          @if (ticket.Service__r.Asymmetrical_Bandwidth__c) {
            / {{ ticket.Service__r.Bandwidth_Upstream__c }}
          }
          @if (ticket.Service__r.Vendor__r) {
            -
            {{
              ticket.Service__r.Vendor__r.Display_Alias__c
                ? ticket.Service__r.Vendor__r.Display_Alias__c
                : ticket.Service__r.Vendor__r.Name
            }}
          }
        </span>
      </div>
    </div>
  </div>
}
@if (
  ticket.Customer_Ticket_Number__c &&
  ticket.RecordType.Name !== TicketRecordType.Care
) {
  <div class="service mt-4 md:mt-2">
    <div class="label">Customer Ticket #</div>
    <!-- To make sure that any care tickets that previously had customer ticket number associated don't display them -->
    <div class="text">
      {{ ticket.Customer_Ticket_Number__c || '---' }}
    </div>
  </div>
}
